// extracts id and value in model notation to single object
export const extractModel = (model) => {
  const data = {};
  model.forEach(item => {
    data[item.id] = item.value;
  });
  return data;
};
